/* @flow */
import cx from 'classnames';
import * as React from 'react';

import BoxBody from 'components/BoxBody';
import Chat from 'entities/Chat';
import ChatActions from 'chat/actions/ChatActions';
import ChatMember from 'entities/ChatMember';
import Dialog from 'components/Dialog';
import Glyph from 'components/Glyph';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
import ModalTrigger from 'components/ModalTrigger';

import ReportChatModalOption from './ReportChatModalOption';
import ReportChatSelectModal from './ReportChatSelectModal';

import './styles/ReportChatModal.scss';

class ReportChatModal extends React.Component<{
  chat: Chat,
  className?: string,
  partner: ChatMember,
}> {
  emailTranscript = () => {
    ChatActions.emailTranscript(this.props.chat.id);
  };
  renderEmailTranscriptOption() {
    return (
      <ReportChatModalOption
        className="ReportChatModal-emailTranscript"
        onClick={this.emailTranscript}>
        <Glyph className="ReportChatModal-glyph" name="email-transcript" />
        Email message history
      </ReportChatModalOption>
    );
  }

  renderReportOption() {
    const modal = <ReportChatSelectModal chat={this.props.chat} partner={this.props.partner} />;

    return (
      <ModalTrigger modal={modal}>
        <ReportChatModalOption className="ReportChatModal-report">
          <Glyph className="ReportChatModal-glyph" name="remind-icon" />
          Report to Remind
        </ReportChatModalOption>
      </ModalTrigger>
    );
  }

  render() {
    const title = (
      <span>
        <Glyph name="flag" size="medium" color="lava" />
        Report
      </span>
    );

    const subtext = (
      <span>
        Safety is a top priority.
        <br />
        {'If someone is not following our '}
        <Link href={LinkConstants.COMMUNITY_GUIDELINES} target="_blank">
          Community Guidelines
        </Link>
        {', you can take the following steps:'}
      </span>
    );

    const body = (
      <div className="ReportChatModal-options">
        {this.renderEmailTranscriptOption()}
        {this.renderReportOption()}
      </div>
    );

    return (
      <Dialog
        eventScreenName="ReportChatModal"
        {...this.props}
        hideCloseButton
        className={cx('ReportChatModal', this.props.className)}
        title={title}
        subtext={subtext}>
        <BoxBody full>{body}</BoxBody>
      </Dialog>
    );
  }
}

export default ReportChatModal;
